import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import ApplicationsAwaitingJoinComp from './ApplicationsAwaitingJoinComp';

function ApplicationsAwaitingJoin() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <ApplicationsAwaitingJoinComp />
      </div>
    </div>
  );
}

export default ApplicationsAwaitingJoin;
